<template>
    <div
        :class="`dh-modal-fixed-container ${value ? '' : 'hide'}`"
    >
        <div
            class="dh-modal-overlay"
            @click="closeOnTouch"
        >
            <div class="dh-modal-body">
                <div
                    class="dh-modal-close"
                    @click="$emit('close')"
                >
                    <a
                        v-if="!$screens.mobile"
                        class="dh-button"
                    >
                        <span>
                            go back
                        </span>
                    </a>
                    <a
                        v-else
                        class="dha-link"
                    >
                        <div class="close-icon">
                            <span class="material-icons">close</span>
                        </div>
                    </a>
                </div>
                <div
                    ref="modalScrollContainer"
                    class="dh-modal-scroll-container"
                >
                    <div
                        ref="content"
                        class="dh-modal-content"
                    >
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true
        },
        touchToClose: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            touchCloseEnabled: this.touchToClose
        };
    },
    watch: {
        value(value) {
            if (value) {
                this.$refs.content.scrollTop = 0;
                document.body.style.overflowY = 'hidden';
            }
        }
    },
    mounted() {
        if (this.value) {
            this.$refs.content.scrollTop = 0;
            document.body.style.overflowY = 'hidden';
        }
        this.$refs.modalScrollContainer.scrollTop = 0;
    },
    methods: {
        closeOnTouch() {
            if (!this.$screens.mobile && this.touchCloseEnabled) {
                this.$emit('close');
            }
        }
    }
};
</script>

<style src="./tabs/common.tab.css" scoped></style>
<style lang="postcss" scoped>
.dh-modal-fixed-container {
    @apply fixed left-0 z-50 w-full;
    transition: opacity 0.25s;
    -webkit-overflow-scrolling: touch;
}

.dh-modal-fixed-container.hide {
    @apply opacity-0 pointer-events-none;
}


/* @media print {
    .dh-modal-fixed-container {
        display: none;
    }
} */

.dh-modal-overlay {
    @apply mx-auto h-full;
    background-color: rgba(0,0,0,0.1);
}

.dh-modal-body {
    @apply relative mx-auto w-full h-full bg-white shadow-lg;
    max-width: 1400px;
}

.dh-modal-close {
    @apply absolute bottom-0 p-2 text-primary-4 z-10 text-center;
    left: calc(50% - 140px);
}

.dh-modal-close .dh-button {
    @apply shadow-lg mx-auto;
}

.dh-modal-scroll-container {
    @apply overflow-y-auto max-h-full w-full;
    /* max-width: 1000px; */
}

.dh-modal-content {
    @apply mx-auto;
    max-width: 1000px;
}

/* @screen sm { */
.dh-modal-fixed-container {
    @apply top-header-sm h-content-height-sm;
}
/* } */
@screen md {
    .dh-modal-fixed-container {
        @apply top-header h-content-height
    }
}
@screen mobile {
    .dh-modal-scroll-container {
        max-width: 100vw;
    }
    .dh-modal-fixed-container {
        height: calc(100vh - 90px);
        max-height: calc(100vh - 90px);
        top: 90px;
    }
    .dh-modal-content {
        min-height: 100vh;
    }
    .dh-modal-close {
        @apply text-neutral-3 cursor-pointer w-4 p-0 mt-3 mr-8 right-0;
        bottom: auto;
        left: auto;
    }

    .close-icon {
        @apply flex relative border-2 border-solid border-neutral-3 justify-center items-center;
        width: 26px;
        height: 26px;
        border-radius: 13px;
        font-size: 16px;
    }
}
</style>
